import { render, staticRenderFns } from "./UnMountUpdateDialog.vue?vue&type=template&id=4cb8d0e8&"
import script from "./UnMountUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./UnMountUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports